// extracted by mini-css-extract-plugin
export var modal = "_v6-0";
export var table = "_v6-1";